
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/calendars",
      function () {
        return require("private-next-pages/android/local/calendars/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/calendars"])
      });
    }
  